import {getField, updateField} from 'vuex-map-fields';
import BaseTableModule from '@/commonFunction/baseTableModule'

let time_tracking = new BaseTableModule('/ws/time_tracker_working_event/');

const state = {
    ...time_tracking.state,
    columns: [
        {text: 'Deleted', value: 'deleted', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Event', value: 'event', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Event start', value: 'event_start', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Event stop', value: 'event_stop', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'User', value: 'calendar_date_user__human_user__user', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Duration', value: 'duration_str', sortable: false, filterable: true, divider: true, brief: true,},
        {text: 'Error', value: 'error_message', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Checked', value: 'checked', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Comment', value: 'comment', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Created by', value: 'created_by', sortable: true, divider: true, brief: true,},
        {text: 'Created on', value: 'created_on', sortable: true, divider: true, brief: true,},
        // {text: 'Edited by', value: 'edited_by', sortable: true, divider: true, brief: true,},
        // {text: 'Edited on', value: 'edited_on', sortable: true, divider: true, brief: true,},
    ],
    columns_brief: [
        {text: 'Deleted', value: 'deleted', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Event', value: 'event', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Event start', value: 'event_start_time', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Event stop', value: 'event_stop_time', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Duration', value: 'duration_str', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Error', value: 'error_message', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Checked', value: 'checked', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Comment', value: 'comment', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Created by', value: 'created_by', sortable: true, divider: true, brief: true,},
        {text: 'Created on', value: 'created_on', sortable: true, divider: true, brief: true,},
    ],
    briefView: true,
    options: {
        page: 1,
        itemsPerPage: 50,
        sortBy: ['-event_start'],
        sortDesc: [false],
        multiSort: false,
        mustSort: true,
        descending: true,
    },
    local_phrase: {
        tracker: {en: 'tracker', de: 'Tracker', color: 'grey darken-1', class: 'timer'},
        working: {en: 'working', de: 'Arbeit', color: 'blue darken-1', class: 'more_time'},
        work_kug: {en: 'work_kug', de: 'KUG', color: 'deep-purple darken-1', class: 'access_time'},
        pause: {en: 'pause', de: 'Pause', color: 'grey darken-1', class: 'pause_circle'},
        time_correction: {en: 'time correction', de: 'Zeitabzug', color: 'brown darken-1', class: 'timer_off'},
        time_add: {en: 'time add', de: 'Zeit-Plus', color: 'light-blue darken-1', class: 'add_alarm'},
        payed: {en: 'Payed', de: 'Payed', color: 'blue-grey lighten-1', class: 'euro_symbol'},
        holiday: {en: 'holiday', de: 'Urlaub', color: 'green darken-1', class: 'beach_access'},
        holiday_extra: {en: 'holiday extra', de: 'Überstunden', color: 'green darken-1', class: 'home'},
        sick: {en: 'sick', de: 'Krank', color: 'amber darken-1', class: 'sick'},
        sick_with_child: {en: 'sick with child', de: 'Kind krank', color: 'amber darken-1', class: 'child_care'},
        sick_kug: {en: 'sick kug', de: 'KUG-Krank', color: 'orange darken-1', class: 'healing'},
    },

};
const getters = {
    ...time_tracking.getters,
    getColumns(state) {
        if (state.briefView) {
            return state.columns_brief
        } else {
            return state.columns
        }
    },
};
const actions = {
    ...time_tracking.actions,
};
const mutations = {
    ...time_tracking.mutations,
};

export default {
    modules: {
        TimeTracker: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}